import { lazyNamed } from 'src/utils/lazyNamed';

export const Placements = {
  List: lazyNamed(() => import('./containers/PlacementsList'), 'PlacementsList'),
  Form: lazyNamed(() => import('./containers/PlacementForm'), 'PlacementForm'),
  PlacementHistory: lazyNamed(() => import('./containers/PlacementHistory'), 'PlacementHistory'),
};
